/**
 * Truncates text to a specified number of words without cutting words mid-word.
 * Handles HTML content by stripping tags before counting words.
 * 
 * @param {string} text - The text to truncate
 * @param {number} wordLimit - Maximum number of words to keep
 * @returns {string} - Truncated text
 */
export function truncateWords(text, wordLimit) {
  if (!text || !wordLimit || wordLimit <= 0) {
    return text || '';
  }

  // Strip HTML tags and decode entities to get plain text
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = text;
  const plainText = tempDiv.textContent || tempDiv.innerText || '';

  // Split into words (handle multiple spaces, tabs, newlines)
  const words = plainText.trim().split(/\s+/).filter(word => word.length > 0);

  // If text is shorter than or equal to limit, return original
  if (words.length <= wordLimit) {
    return text;
  }

  // Get the first N words and join them
  const truncatedWords = words.slice(0, wordLimit);
  return truncatedWords.join(' ') + '...';
}

